import React, { Fragment } from 'react';
import { Carousel, Intro, Voiceover } from 'dea-core';
import img1 from '../../assets/images/U1-T1-02A.svg';
import img2 from '../../assets/images/U1-T1-02B.svg';
import img3 from '../../assets/images/U1-T1-02C.svg';
import voAudio from '../../assets/vo/Opioid-M-One-02.mp3';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript: <p>Have you seen or heard headlines like this?</p>
};

const data = {
  slides: [
    {
      image: img1,
      imageText: '',
      text: {
        title: '17 Overdoses Last Night in Our City. 3 Deaths.'
      }
    },
    {
      image: img2,
      imageText: '',
      text: {
        title: '130 People Die from Opioid Overdose Every Day'
      }
    },
    {
      image: img3,
      imageText: '',
      text: {
        title:
          'Single Pharmacy Filled More Opioid Prescriptions than the Number of Local Residents Last Year'
      }
    }
  ]
};

export default {
  title: 'Making Headlines',
  path: '/engage/making-headlines',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        direction="Use the arrows to learn more."
        title="Making Headlines"
      />
      <Carousel data={data} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/engage/MakingHeadlines.js